module.exports = __webpack_public_path__ + "static/fonts/iconfont.dd7537bf.eot";